import styled from 'styled-components'
const Container = styled.div`
  width: 95%;
  @media (max-width: ${({ theme }) => theme.responsive.mobile}) {
    width: 100%;
  }
  @media (max-width: 340px) {
    width: 100%;
  }
  .center {
    text-align: center;
    justify-content: center;
    display: flex;
    align-items: center;
  }
`
const Wrapper = styled.div`
  width: 97%;
  margin-bottom: 20px;
  p {
    font-family: ${({ theme }) => theme.fontFamily.Euclid};
    font-style: normal;
    font-weight: normal;
    font-size: ${({ theme }) => theme.fontSize.x3};
    line-height: 15px;
    color: ${({ theme }) => theme.colors.gray};
    @media (max-width: ${({ theme }) => theme.responsive.mobile}) {
      margin-top: -10px;
      width: 100%;
    }
    @media (min-width: ${({ theme }) =>
        theme.responsive.ipad}) and (max-width: 995px) {
      margin-top: -10px;
    }
  }
`
const BaseList = styled.div`
  width: 100%;
  height: auto;
  background-color: ${({ theme }) => theme.colors.Cardwhite};
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-radius: 10px;
  margin-bottom: 30px;
  background-color: #f8f9fe;
  padding: 0px 10px;
  border-radius: 10px;
  @media (max-width: ${({ theme }) => theme.responsive.mobile}) {
    flex-direction: column;
    height: auto;
  }
  @media (max-width: 340px) {
    height: auto;
  }
`
const Description = styled.div`
  width: 47%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  @media (max-width: ${({ theme }) => theme.responsive.mobile}) {
    width: 100%;
  }

  .desc {
    padding-left: 15px;
    @media (max-width: ${({ theme }) => theme.responsive.mobile}) {
      padding-left: 8px;
      width: 100%;
    }
    @media (min-width: ${({ theme }) =>
        theme.responsive.ipad}) and (max-width: 995px) {
      padding-left: 8px;
    }
  }
  .amount_item {
    @media (max-width: ${({ theme }) => theme.responsive.mobile}) {
      padding-right: 20px;
    }
  }
  .direction {
    display: flex;
    align-items: center;
  }
  h2 {
    width: 70%;
    font-size: ${({ theme }) => theme.fontSize.x2};
    font-family: ${({ theme }) => theme.fontFamily.visuelt};
    font-style: normal;
    font-weight: 500;
    font-size: 18px;
    line-height: 23px;
    color: ${({ theme }) => theme.colors.dark};
    @media (max-width: ${({ theme }) => theme.responsive.mobile}) {
      font-size: ${({ theme }) => theme.fontSize.s};
    }
    @media (min-width: ${({ theme }) =>
        theme.responsive.ipad}) and (max-width: 995px) {
      font-size: ${({ theme }) => theme.fontSize.s};
      /* width:10000px; */
    }
    @media (max-width: 401px) {
      width: 100%;
    }
  }
  h3 {
    font-size: ${({ theme }) => theme.fontSize.x3};
    color: ${({ theme }) => theme.colors.successGreen};
    font-family: Euclid Circular A;
    font-style: normal;
    font-weight: normal;
    @media (max-width: ${({ theme }) => theme.responsive.mobile}) {
      font-size: ${({ theme }) => theme.fontSize.x5};
    }
    @media (min-width: ${({ theme }) =>
        theme.responsive.ipad}) and (max-width: 995px) {
      font-size: ${({ theme }) => theme.fontSize.x5};
    }
  }
`
const Amount = styled.div`
  width: 43%;
  display: flex;
  display: flex;
  justify-content: space-between;
  align-items: center;
  @media (max-width: ${({ theme }) => theme.responsive.mobile}) {
    width: 100%;
    margin-top: -15px;
    padding-left: 80px;
  }
  .amount_item {
    @media (max-width: ${({ theme }) => theme.responsive.mobile}) {
      padding-right: 60px;
    }
  }
  h3 {
    font-size: ${({ theme }) => theme.fontSize.x3};
    color: ${({ theme }) => theme.colors.successGreen};
    font-family: Euclid Circular A;
    font-style: normal;
    font-weight: normal;
    @media (max-width: ${({ theme }) => theme.responsive.mobile}) {
      font-size: ${({ theme }) => theme.fontSize.x5};
    }
    @media (min-width: ${({ theme }) =>
        theme.responsive.ipad}) and (max-width: 995px) {
      font-size: ${({ theme }) => theme.fontSize.x5};
    }
  }
  .end {
    align-self: center;
    @media (max-width: ${({ theme }) => theme.responsive.mobile}) {
      align-self: end;
    }
  }
`
export { Wrapper, Container, BaseList, Description, Amount }
